import React, { useEffect, useState } from 'react'
import { postData } from '../../services/api'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highcharts'
import { Box, Checkbox, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
export default function SellingTrendByMonth({ catalogs, types }) {
    const [type, setType] = useState('all')
    const [catalog, setCatalog] = useState([])
    const [catalogNo, setCatalogNo] = useState([])
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const getData = async () => {
        const body = {
            BranchNo:
                []
            ,
            Season:
                []
            ,
            TypeNo:
                type === 'all' ? [] : [type],
            CatalogNo: catalogNo,
            BudgetYear: [],
            Month: [],
            Day: []
        }
        setIsLoading(true)
        const res = await postData('dashboard/back/selling-trend-by-month', body)
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [type, catalogNo])
    const handleChange = (event) => {

        const {
            target: { value },
        } = event;

        setCatalog(
            // On autofill we get a stringified value.
            value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogName) : value,
        );
        setCatalogNo(value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogNo) : value.map((x) => catalogs?.find((y) => y?.CatalogName === x)?.CatalogNo));

    };
    return (
        <>
            <div class="row">
                <Box sx={{ display: 'flex', flexDirection: 'column' , justifyContent: "space-between" }}>
                    <h2 className='dash-title'>
                        เเนวโน้มการจำหน่ายรายเดือน
                    </h2>
                    <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "flex-end" , '& .backgroundField': { background: "#d8ceff" } }}>

                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={type}
                                    onChange={e => setType(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ชนิดข้าวทั้งหมด</MenuItem>
                                    {types?.map((x, i) => (
                                        <MenuItem value={x?.TypeNo}>{x?.TypeName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            {/* <FormControl variant="standard" fullWidth >
                                <Select value={catalog}
                                    onChange={e => setCatalog(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                    {catalogs?.map((x, i) => (
                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl> */}
                           
                            <FormControl variant="standard" sx={{ width: 120 }} >
                                <Select value={catalog}
                                    // onChange={e => setCatalog(e.target.value)}
                                    multiple
                                    displayEmpty
                                    // value={personName}
                                    onChange={handleChange}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <>พันธุ์</>;
                                        }
                                        return selected?.join(', ')
                                    }}
                                    MenuProps={MenuProps}
                                    disableUnderline
                                // MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {/* <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                {catalogs?.map((x, i) => (
                                    <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                ))} */}
                                    <MenuItem value="all">
                                        <Checkbox checked={catalog?.length === catalogs?.length} />
                                        <ListItemText primary={'พันธุ์ทั้งหมด'} />
                                    </MenuItem>
                                    {catalogs?.map((name, i) => (
                                        <MenuItem key={i} value={name?.CatalogName}>
                                            <Checkbox checked={catalog?.indexOf(name?.CatalogName) > -1} />
                                            <ListItemText primary={name?.CatalogName} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </div >
            <div class="row">
                <div class="col-12">
                    {!isLoading && <Dashboard dataDashboard={data} />}
                </div>
            </div>
        </>
    )
}
function Dashboard({ dataDashboard }) {


    let category = [];
    let series = [{
        name: 'ปีที่แล้ว',
        data: [],
        type: 'column',
        color:"#007FFF"
    }, {
        name: 'ปีนี้',
        data: [],
        type: 'column',
        color:"#ff5757"
    }, {
        name: 'แนวโน้ม',
        data: [],
        type: 'line',
        color:'#00FF00'
    }];
    if (dataDashboard.length > 0) {

        for (let i = 0; i < dataDashboard.length; i++) {
            category.push(dataDashboard[i].SaleMonth);

            series[0].data.push(+(+dataDashboard[i].OldQty / 1000)?.toFixed(2));
            series[1].data.push(+(+dataDashboard[i].LastQty / 1000)?.toFixed(2));
            series[2].data.push(+((+dataDashboard[i].LastQty / 1000 + +dataDashboard[i].OldQty / 1000) / 2)?.toFixed(2));

        }
    }
    const options = {
        chart: {
            type: 'column',
            // scrollablePlotArea: {
            //     minWidth: 1000,
            //     scrollPositionX: 1
            // }
            zoomType: 'x'
        },
        title: {
            text: null
        },
        subtitle: {
            text: 'หน่วย : ตัน',
            align: 'left'
        },

        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        xAxis: {
            categories: category,
            title: {
                text: 'เดือน'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return this.value.toLocaleString();
                },
            }

        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
            x: -40,
            y: 80,
            floating: true,
            borderWidth: 1,
            backgroundColor:
                Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            shadow: true
        },

        tooltip: {
            pointFormat: '<b>{point.y}</b>'
        },
        plotOptions: {
            series: {
                borderRadiusTopLeft: 8,
                borderRadiusTopRight: 8
            },
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: series

    }
    return (
        <>{dataDashboard && <PieChart options={options} highcharts={Highcharts} />}</>
    )
}

